import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/system";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Icons from "../../Components/Icons/icons";
import { Background, ButtonWithGlyphIcon, FullScreenLoader, NavBar } from "../../Components/index";
import { ROUTE_CONNECTION_STEPS, ROUTE_GENERIC_PAGE, ROUTE_INSTA_EDUCATION_PAGE, ROUTE_INVITE_EXPIRED } from "../../Routes/RouteMapping";
import {
  INSTAGRAM_WORK_PLATFORM_ID,
  STORAGE_WORK_PLATFORM_ID,
  TIKTOK_WORK_PLATFORM_ID,
  YOUTUBE_WORK_PLATFORM_ID,
  STORAGE_AUTH_DATA,
  STORAGE_AUTH_SDK_TOKEN,
  STORAGE_AUTH_USER_ID,
  STORAGE_AUTH_TENANT_APP_NAME,
  URL_QUERY_PARAMS_INVITE_CODE,
  URL_QUERY_PARAMS_ENVIRONMENT,
  STORAGE_AUTH_CREATOR_USER_NAME,
  STORAGE_CREATOR_INVITE_ID,
  STORAGE_WORK_PLATFORM_NAME,
  STORAGE_CREATOR_ENVIRONMENT,
  FACEBOOK_WORK_PLATFORM_ID,
  TWITTER_WORK_PLATFORM_ID,
  TWITCH_WORK_PLATFORM_ID,
  LANDING_PAGE_CONTENT,
  CONNECTED_ACCOUNT_ID,
} from "../../utils/constants";
import { getSDKConfig } from "../../utils/api";
import "./LandingPage.scss";
import { trackEvent } from "../../analytics";
import { MICROSITE_LANDING_PAGE_VIEW, MICROSITE_CONNECT_ACCOUNT_INITIATED } from "../../analytics";
import { PlatformIconBox } from "../../Components/PlatformIconBox/PlatformIconBox";
import { Grid } from "@mui/material";
function LandingPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [appName, setAppName] = useState();
  const [userName, setUserName] = useState();
  const onlyOnce = useRef(true);
  const loganalyticsEventOnlyOnce = useRef(true);
  const [isLoading, SetIsLoading] = useState(true);

  async function setAuthDetails() {
    const inviteCode = searchParams.get(URL_QUERY_PARAMS_INVITE_CODE);
    const env = searchParams.get(URL_QUERY_PARAMS_ENVIRONMENT);

    sessionStorage.setItem(STORAGE_CREATOR_ENVIRONMENT, env);
    SetIsLoading(true);
    if (inviteCode && env) {
      const response = await getSDKConfig(inviteCode, env);
      if (response && response.sdk_token) {
        const auth = {
          [STORAGE_AUTH_SDK_TOKEN]: response.sdk_token,
          [STORAGE_AUTH_TENANT_APP_NAME]: response.tenant_app_name,
          [STORAGE_AUTH_USER_ID]: response.user_id,
          [STORAGE_AUTH_CREATOR_USER_NAME]: response.creator_name,
        };
        sessionStorage.setItem(STORAGE_AUTH_DATA, JSON.stringify(auth));
        sessionStorage.setItem(STORAGE_CREATOR_INVITE_ID, inviteCode);
        if (loganalyticsEventOnlyOnce.current) {
          trackEvent(MICROSITE_LANDING_PAGE_VIEW);
          loganalyticsEventOnlyOnce.current = false;
        }
        setAppName(response.tenant_app_name);
        setUserName(response.creator_name);
        SetIsLoading(false);
      } else {
        // console.error("Error in fetching SDK config");
        SetIsLoading(false);
        if (response && response.error.http_status_code === 403) {
          const errorMessage = response.error.message;
          navigate(ROUTE_INVITE_EXPIRED, { state: { errorMessage } });
        } else throw new Error("Error in fetching SDK config", response.error.message);
      }
    } else {
      SetIsLoading(false);
      throw new Error("Invite code or environment not found in query params");
    }
  }

  useEffect(() => {
    (async () => {
      const inviteCode = searchParams.get(URL_QUERY_PARAMS_INVITE_CODE);
      // to remove earlier connected account ids
      sessionStorage.removeItem(CONNECTED_ACCOUNT_ID);
      if (!sessionStorage.getItem(STORAGE_AUTH_DATA) || (inviteCode && sessionStorage.getItem(STORAGE_CREATOR_INVITE_ID) !== inviteCode)) {
        if (onlyOnce.current) {
          onlyOnce.current = false;
          await setAuthDetails();
        }
      } else {
        const authData = JSON.parse(sessionStorage.getItem(STORAGE_AUTH_DATA));
        setAppName(authData[STORAGE_AUTH_TENANT_APP_NAME]);
        setUserName(authData[STORAGE_AUTH_CREATOR_USER_NAME]);
        SetIsLoading(false);
      }
    })();
  }, []);

  //set workplatform id and navigate
  const navigateToEducationPage = (id, workPlatformName) => {
    sessionStorage.setItem(STORAGE_WORK_PLATFORM_ID, id);
    sessionStorage.setItem(STORAGE_WORK_PLATFORM_NAME, workPlatformName);
    if (id === INSTAGRAM_WORK_PLATFORM_ID) {
      navigate(ROUTE_INSTA_EDUCATION_PAGE);
      return;
    } else {
      navigate(ROUTE_GENERIC_PAGE);
      return;
    }
  };

  const onClickPlatform = (workplatformId, workplatformName) => {
    trackEvent(MICROSITE_CONNECT_ACCOUNT_INITIATED, {
      work_platform_name: workplatformName,
    });
    navigateToEducationPage(workplatformId, workplatformName);
  };

  if (isLoading) {
    return <FullScreenLoader showLoader={isLoading} />;
  }
  return (
    <>
      <Background>
        <Box className="landing-page-body">
          <label className="creator-name">{LANDING_PAGE_CONTENT.invite_header.replace("userName", userName)}</label>
          <Box className="description">
            <label>
              <label className="appName">{appName}</label> {LANDING_PAGE_CONTENT.invite_message}
            </label>
          </Box>
          <Box className="workflow-btns-container">
            <Grid container spacing={1} className="grid-icon-container">
              <Grid>
                <PlatformIconBox
                  icon={<Icons.instagramIcon />}
                  text={"Instagram"}
                  id={INSTAGRAM_WORK_PLATFORM_ID}
                  onClickPlatform={onClickPlatform}
                />
              </Grid>
              <Grid>
                <PlatformIconBox icon={<Icons.tiktokIcon />} text={"TikTok"} id={TIKTOK_WORK_PLATFORM_ID} onClickPlatform={onClickPlatform} />
              </Grid>
              <Grid>
                <PlatformIconBox icon={<Icons.youtubeIcon />} text={"YouTube"} id={YOUTUBE_WORK_PLATFORM_ID} onClickPlatform={onClickPlatform} />
              </Grid>
            </Grid>
            <Grid container spacing={1} className="grid-icon-container">
              <Grid>
                <PlatformIconBox icon={<Icons.facebookIcon />} text={"Facebook"} id={FACEBOOK_WORK_PLATFORM_ID} onClickPlatform={onClickPlatform} />
              </Grid>
              <Grid>
                <PlatformIconBox icon={<Icons.twitterIcon />} text={"Twitter"} id={TWITTER_WORK_PLATFORM_ID} onClickPlatform={onClickPlatform} />
              </Grid>
              <Grid>
                <PlatformIconBox icon={<Icons.twitchIcon />} text={"Twitch"} id={TWITCH_WORK_PLATFORM_ID} onClickPlatform={onClickPlatform} />
              </Grid>
            </Grid>
          </Box>
          <Box className="footer-link-text">
            <a onClick={() => navigate(ROUTE_CONNECTION_STEPS)} target="_blank">
              <label className="footer-link-text">{LANDING_PAGE_CONTENT.footer_link_text}</label>
            </a>
          </Box>
        </Box>
      </Background>
    </>
  );
}

export default LandingPage;
